import { SxProps, Theme } from '@mui/material';

type BrandChipVariant = 'primary' | 'outlined' | 'filled';

export const brandChipSx = (variant: BrandChipVariant = 'outlined', extra?: SxProps<Theme>): SxProps<Theme> => {
  const base: SxProps<Theme> = {
    fontFamily: 'AzbukaPro, sans-serif',
    fontWeight: 500,
    textTransform: 'none',
    borderRadius: '16px',
  };

  if (variant === 'primary') {
    return { ...base, bgcolor: '#B3EC49', color: 'black', border: 'none', ...extra } as SxProps<Theme>;
  }
  if (variant === 'filled') {
    return { ...base, bgcolor: 'rgba(255,255,255,0.08)', color: 'white', border: 'none', ...extra } as SxProps<Theme>;
  }
  return {
    ...base,
    bgcolor: 'transparent',
    color: 'rgba(255, 255, 255, 0.85)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    ...extra,
  } as SxProps<Theme>;
};
